export default __webpack_public_path__ + "assets/29dad9feb22a535066c2074a1f53e561.svg";